import styled from 'styled-components';

import { PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';

export const UamOutlineButton = styled(PrsDefaultButton)`
  background-color: white;
  border: 1px solid #0600b4;
  color: #0600b4;
  :hover {
    background-color: #f0efff;
    border-color: #0600b4;
    color: #0600b4;
  }
  :disabled {
    background-color: white;
    border-color: #cbcacc;
    color: #cbcacc;
  }
`;

export const UamFullWidthButton = styled(PrsDefaultButton)`
  width: 100%;
`;

export const UamFullWidthOutlineButton = styled(UamOutlineButton)`
  width: 100%;
`;

export const UamResendLink = styled.a`
  color: #0600b4;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

export const ForgotPasswordLink = styled.a`
  font-size: 16px;
  color: rgb(3, 0, 165);
`;
